module.exports = ".form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {\n  border: 1px solid #ccc !important;\n  background-color: lightgray !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/create-application/pfi-form/workrequest-pfi/workrequest-pfi.component.css
// module id = ./src/app/create-application/pfi-form/workrequest-pfi/workrequest-pfi.component.css
// module chunks = main